import React, { PropsWithChildren, useState } from 'react';

import { useIntl } from 'react-intl';

import ActionButton from 'components/action-button';
import IconError from 'components/error-boundary-static/icon';
import { useReload } from 'components/error-boundary-static/use-reload';
import { LogUserErrorSeverity, logUserErrorMessage } from 'hooks/log-user-error-message';
import { useRoute } from 'hooks/navigation/use-route';
import useEffectOnce from 'hooks/use-effect-once';
import crashlytics from 'utils/crashlytics';
import logger from 'utils/logger';

import { Container, Header, Inner } from './styles';

type BlankScreenLoggerProps = PropsWithChildren<{
  context: {
    reason: string;
    [key: string]: any;
  };
  onReload?: () => void;
}>;

export const BlankScreen = ({ context, children, onReload }: BlankScreenLoggerProps) => {
  const route = useRoute();
  const { formatMessage } = useIntl();
  const [forceReloadApp, setForceReloadApp] = useState(false);
  const message = `[BlankScreen] Screen pathname: ${route.pathname}`;

  const handleReload = useReload(() => {
    if (!forceReloadApp && onReload) {
      onReload();
      setForceReloadApp(true);
      return;
    }

    crashlytics().log(message);
    crashlytics().crash();
  });

  useEffectOnce(() => {
    logger.warn({
      message,
      context: {
        ...context,
        route,
      },
    });
    logUserErrorMessage({
      message,
      severity: LogUserErrorSeverity.Recoverable,
      context: {
        moreInfo: 'blank-screen.tsx',
        ...context,
      },
    });
  });

  if (children) {
    return <>children</>;
  }

  return (
    <Container>
      <Inner>
        <IconError />
        <Header>
          {formatMessage({ id: 'loyaltyUnavailableInRegionOops' })}{' '}
          {formatMessage({ id: 'somethingWrong' })}
        </Header>
        <ActionButton onPress={handleReload}>{formatMessage({ id: 'reload' })}</ActionButton>
      </Inner>
    </Container>
  );
};
